<template>
    <div>
        <div class="btn-wrap">
                <div class="btn-list">
                    <a-button type="primary" @click="openAdd"><template #icon><plus-outlined /></template>添加会员</a-button>
                    <a-button type="danger" @click="delMore"><template #icon><delete-outlined /></template>删除</a-button>
                </div>
                <div>
                    <a-input-group compact>
                        <a-input v-model:value="search"  placeholder="请输入会员姓名"/>
                        <a-button type="primary" @click="toSearch">搜索</a-button>
                    </a-input-group>
                </div>
            </div>

            <a-table row-key="id" :pagination="false" :columns="columns" :data-source="dataList.arr" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
                <template #bodyCell="{ column,record}">
                    <template v-if="column.dataIndex === 'is_browser'">
                        <template v-for="item,i in record.is_browser" :Key="i">
                            <p v-if="item=='1'">屏蔽pc</p>
                            <p v-if="item=='2'">屏蔽手机</p>
                            <p v-if="item=='3'">屏蔽pc虚拟浏览器</p>
                        </template>
                        
                    </template>

                    <template v-if="column.dataIndex === 'operation'">
                        <a-button type="link" @click="openEdit(record.id)">编辑</a-button>
                        <a-button type="link" @click="del(record.id)">删除</a-button>
                    </template>
                </template>
            </a-table>

            <a-pagination
                v-model:pageSize="page.pageSize"
                show-size-changer
                :total="page.total"
                @change="pageChange"
                :show-total="total => `共 ${total} 条数据`"
            />

        <!-- 添加、编辑账户 -->
        <a-modal v-model:visible="visible" :title="title" @ok="handleOk" >
            <!-- <div style="width:390px"> -->
                <a-form
                    :model="formData.data"
                    :label-col="{ span: 4 }"
                    :wrapper-col="{ span: 20 }"
                    autocomplete="off"
                >
                    <a-form-item label="姓名" name="username" >
                        <a-input placeholder="姓名" v-model:value="formData.data.username" />
                    </a-form-item>

                    <a-form-item label="手机号" name="telephone" >
                        <a-input placeholder="手机号" type="tel" v-model:value="formData.data.telephone" />
                    </a-form-item>
                
                    <a-form-item label="密码" name="password" >
                        <a-input-password placeholder="密码" v-model:value="formData.data.password" />
                    </a-form-item>
                    <a-form-item label="确认密码" name="repassword" >
                        <a-input-password placeholder="确认密码" v-model:value="formData.data.repassword" />
                    </a-form-item>
                    <a-form-item label="推广关键词" name="telephone" >
                        <a-input placeholder="推广关键词" type="tel" v-model:value="formData.data.bd_vid" />
                    </a-form-item>
                    <a-form-item label="失败跳转" name="telephone" >
                        <a-input placeholder="失败跳转链接" type="tel" v-model:value="formData.data.interlinkage_fail" />
                    </a-form-item>
                    <a-form-item label="屏蔽设备" name="telephone" >
                        <a-checkbox-group v-model:value="formData.data.is_browser">
                            <a-checkbox :value="1">屏蔽pc</a-checkbox>
                            <a-checkbox :value="2">屏蔽手机</a-checkbox>
                            <a-checkbox :value="3">屏蔽pc虚拟浏览器</a-checkbox>
                        </a-checkbox-group>
                    </a-form-item>
                </a-form>
            <!-- </div> -->
             
        </a-modal>
    </div>
</template>

<script>
import { reactive,ref } from 'vue';
import {ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { getCurrentInstance ,createVNode} from 'vue'
import { message,Modal} from 'ant-design-vue';
const columns = [
    {title: 'ID',dataIndex: 'id',width:90},
    {title: '姓名',dataIndex: 'username'},
    {title: '手机号',dataIndex: 'telephone'},
    {title: '推广关键词',dataIndex: 'bd_vid'},
    {title: '所属管理员',dataIndex: 'dmin_user_username'},
    {title: '屏蔽设备',dataIndex: 'is_browser',width:100},
    {title: '失败跳转',dataIndex: 'interlinkage_fail',width:230},
    {title: '添加时间',dataIndex: 'create_time'},
    {title: '操作',dataIndex: 'operation',width:180}
];
export default {
    setup(){
        const { proxy } = getCurrentInstance()
        let dataList=reactive({arr:[]})
        
        let page=reactive({page:"",pageSize:"10",total:"20"})//分页

        // 搜索
        let search=ref()
        let toSearch=function(){
            page.page="1"
            getTabledata()
        }



        // 列表
         let getTabledata=function(){
            proxy.$http.post('/admin/userlist',{page:page.page,pagesize:page.pageSize,search:search.value},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    dataList.arr=res.data.data.data
                    page.total=res.data.data.total
                }else{
                    message.error(res.data.msg);
                }
            });
        }
        getTabledata()

        // 添加、编辑
        let formData=reactive({data:{username:"",telephone:"",password:"",repassword:"",bd_vid:"",interlinkage_fail:"",is_browser:""}})
        let title=ref("")
        let visible=ref(false)
        let openAdd=function(){
            formData.data.username=""
            formData.data.telephone=""
            formData.data.repassword=""
            formData.data.password=""
            formData.data.bd_vid=""
            formData.data.interlinkage_fail=""
            formData.data.is_browser=0
            title.value="添加会员"
            visible.value=true
        }

        let openEdit=function(id){
            proxy.$http.post('/admin/userpage',{id:id},{
                headers:{
                    'token':sessionStorage.getItem("token")
                }
            }).then((res) => {
                if(res.data.status==200){
                    visible.value=true
                    title.value="编辑会员"
                    formData.data=res.data.data.data
                    // formData.data.is_browser=["3"]
                    if(res.data.data.data.is_browser[0]){
                        var arr=[]
                        for(var i in res.data.data.data.is_browser){
                            arr.push(parseInt(res.data.data.data.is_browser[i]) )
                        }
                        formData.data.is_browser=arr
                    }
                    
                    formData.data.password=""
                    formData.data.repassword=""
                }else{
                    message.error(res.data.msg);
                }
            });
        }

        let handleOk=function(){

            if(formData.data.password!=formData.data.repassword){
                message.error("两次密码不一致")
                return false
            }
            var is_browser=""
            if(formData.data.is_browser[0]){
                is_browser=formData.data.is_browser.join(",")
            }
            if(title.value=="添加会员"){
               
                proxy.$http.post('/admin/adduser',{username:formData.data.username,telephone:formData.data.telephone,password:formData.data.password,
                admin_user_id:sessionStorage.getItem("userid"),bd_vid:formData.data.bd_vid,interlinkage_fail:formData.data.interlinkage_fail,is_browser:is_browser},{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        visible.value=false
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
                
                
            }else if(title.value=="编辑会员"){
                proxy.$http.post('/admin/updateuser',{id:formData.data.id,username:formData.data.username,telephone:formData.data.telephone,password:formData.data.password,
                admin_user_id:sessionStorage.getItem("userid"),bd_vid:formData.data.bd_vid,interlinkage_fail:formData.data.interlinkage_fail,is_browser:is_browser},{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        visible.value=false
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
            }
        }
        // 多选
        let selectedRowKeys=ref()
        let onSelectChange=function(selected) {
            selectedRowKeys.value = selected;
        }

         // 删除
        let delMore=function(){
            var id=selectedRowKeys.value.join(",")
            del(id)
        }
        let del=function(id){
            Modal.confirm({
                title: '你确定要删除吗？',
                icon: createVNode(ExclamationCircleOutlined),
            onOk() {
                proxy.$http.post('/admin/deluser',{ids:id},{
                    headers:{
                        'token':sessionStorage.getItem("token")
                    }
                }).then((res) => {
                    if(res.data.status==200){
                        message.success(res.data.msg)
                        getTabledata()
                    }else{
                        message.error(res.data.msg);
                    }
                });
            },
            onCancel() {
             console.log('Cancel');
            }
            })
            
        }



        // 分页
        let pageChange=function(current, size){
            page.pageSize=size
            page.page=current
            getTabledata()
        }
        return{
            toSearch,search,
            visible,formData,openAdd,title,handleOk,openEdit,
            onSelectChange,delMore,del,selectedRowKeys,
            columns,dataList,pageChange,page
        }
    }
}
</script>